(() => {
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const body=document.body;
  const openPanel=(panel,overlay)=>{ if(panel){panel.classList.add('is-open');panel.setAttribute('aria-hidden','false')} if(overlay) overlay.hidden=false; body.classList.add('no-scroll') };
  const closePanel=(panel,overlay)=>{ if(panel){panel.classList.remove('is-open');panel.setAttribute('aria-hidden','true')} if(overlay) overlay.hidden=true; body.classList.remove('no-scroll') };

  const cartDrawer=$('[data-cart-drawer]'), cartOverlay=$('[data-cart-overlay]');
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',()=>openPanel(cartDrawer,cartOverlay)));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click',()=>closePanel(cartDrawer,cartOverlay)));
  cartOverlay?.addEventListener('click',()=>closePanel(cartDrawer,cartOverlay));

  const searchDrawer=$('[data-search-drawer]'), searchOverlay=$('[data-search-overlay]');
  $$('[data-search-open]').forEach(b=>b.addEventListener('click',()=>openPanel(searchDrawer,searchOverlay)));
  $$('[data-search-close]').forEach(b=>b.addEventListener('click',()=>closePanel(searchDrawer,searchOverlay)));
  searchOverlay?.addEventListener('click',()=>closePanel(searchDrawer,searchOverlay));

  const mobileMenu=$('[data-mobile-menu]');
  $('[data-mobile-menu-open]')?.addEventListener('click',()=>{mobileMenu.hidden=false;body.classList.add('no-scroll')});
  $('[data-mobile-menu-close]')?.addEventListener('click',()=>{mobileMenu.hidden=true;body.classList.remove('no-scroll')});

  const filter=$('[data-filter-panel]');
  $('[data-filter-open]')?.addEventListener('click',()=>{filter?.classList.add('is-open');body.classList.add('no-scroll')});
  $('[data-filter-close]')?.addEventListener('click',()=>{filter?.classList.remove('is-open');body.classList.remove('no-scroll')});

  const shopRoot=()=>((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/');
  async function getCart(){
    const r=await fetch(`${shopRoot()}cart.js`,{headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Could not load cart');
    return r.json();
  }
  async function refreshCart(open=true){
    const sectionUrl=`${shopRoot()}?section_id=cart-drawer`;
    const html=await fetch(sectionUrl,{headers:{Accept:'text/html'}}).then(async r=>{
      if(!r.ok) throw new Error('Could not refresh cart');
      return r.text();
    });
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.querySelector('[data-cart-drawer]');
    if(fresh && cartDrawer) cartDrawer.innerHTML=fresh.innerHTML;
    const cart=await getCart();
    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    bindCartControls();
    if(open) openPanel(cartDrawer,cartOverlay);
  }
  async function cartError(response){
    try{
      const data=await response.json();
      return data.description||data.message||data.status||`Cart error (${response.status})`;
    }catch(_){
      return `Cart error (${response.status})`;
    }
  }
  async function addVariant(id,qty=1){
    const fd=new FormData();
    fd.append('id',String(id));
    fd.append('quantity',String(qty));
    const r=await fetch(`${shopRoot()}cart/add.js`,{
      method:'POST',
      headers:{Accept:'application/json'},
      body:fd
    });
    if(!r.ok) throw new Error(await cartError(r));
    await refreshCart(true);
  }
  async function addProductForm(form){
    const fd=new FormData(form);
    const r=await fetch(`${shopRoot()}cart/add.js`,{
      method:'POST',
      headers:{Accept:'application/json'},
      body:fd
    });
    if(!r.ok) throw new Error(await cartError(r));
    await refreshCart(true);
  }
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-quick-add]'); if(!btn) return;
    e.preventDefault(); btn.disabled=true;
    try{await addVariant(btn.dataset.variantId,1)}catch(err){alert(err.message)}finally{btn.disabled=false}
  });

  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-upsell-variant]'); if(!select) return;
    const card=select.closest('.upsell-card');
    const add=card?.querySelector('[data-quick-add]');
    if(add) add.dataset.variantId=select.value;
  });

  function bindCartControls(){
    $$('[data-cart-qty]',cartDrawer).forEach(btn=>btn.onclick=async()=>{
      btn.disabled=true;
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(btn.dataset.line),quantity:Number(btn.dataset.qty)})});
      await refreshCart(true);
    });
    $$('[data-cart-close]',cartDrawer).forEach(b=>b.onclick=()=>closePanel(cartDrawer,cartOverlay));
  }
  bindCartControls();

  function showProductMedia(id){
    const panels=$$('[data-media-panel]');
    if(!id || !panels.some(panel=>panel.dataset.mediaPanel===String(id))) return;
    panels.forEach(panel=>{
      const active=panel.dataset.mediaPanel===String(id);
      if(!active && !panel.hidden){
        $$('video',panel).forEach(video=>video.pause());
        $$('iframe',panel).forEach(frame=>{frame.src=frame.src});
      }
      panel.hidden=!active;
    });
    $$('[data-product-thumb]').forEach(button=>{
      const active=button.dataset.mediaId===String(id);
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  function updateStickyDetails(){
    const selected=$('[data-sticky-variant]')?.selectedOptions[0];
    if(!selected) return;
    const money=v=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(Number(v)/100);
    const price=Number(selected.dataset.price), compare=Number(selected.dataset.compare), onSale=compare>price;
    const sale=$('[data-sticky-sale-price]'), old=$('[data-sticky-compare-price]'), badge=$('[data-sticky-save-badge]'), img=$('[data-sticky-product-image]');
    if(sale) sale.textContent=money(price);
    if(old){old.hidden=!onSale;old.textContent=onSale?money(compare):''}
    if(badge){badge.hidden=!onSale;badge.textContent=onSale?`Save ${Math.round((compare-price)*100/compare)}%`:''}
    if(img && selected.dataset.image){img.src=selected.dataset.image;img.removeAttribute('srcset')}
    const button=$('[data-sticky-product-form] button[type=submit]');
    if(button){button.disabled=selected.dataset.available!=='true';button.textContent=button.disabled?'SOLD OUT':'ADD TO CART'}
  }

  const form=$('[data-product-form]');
  if(form){
    const select=$('[data-variant-select]',form), price=$('[data-product-price]');
    const syncVariant=()=>{
      const chosen=$$('input[type=radio]:checked',form).map(i=>i.value);
      const option=$$('option',select).find(o=>{ try{return JSON.parse(o.dataset.options).every((v,i)=>v===chosen[i])}catch{return false} });
      if(option){
        select.value=option.value;
        const stickySelect=$('[data-sticky-variant]');
        const stickyFormForSync=stickySelect?.closest('[data-sticky-product-form]');
        if(stickySelect && stickyFormForSync?.dataset.stickyFollowsMain==='true'){
          stickySelect.value=option.value;
          const stickyButton=$('button[type=submit]',stickyFormForSync);
          if(stickyButton) stickyButton.disabled=option.dataset.available!=='true';
        }
        showProductMedia(option.dataset.mediaId);
        updateStickyDetails();
        const money=v=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(Number(v)/100);
        if(price){
          price.innerHTML=money(option.dataset.price)+(Number(option.dataset.compare)>Number(option.dataset.price)?` <s>${money(option.dataset.compare)}</s>`:'');
        }
        const dealPrice=$('[data-deal-price]'), dealCompare=$('[data-deal-compare]'), dealDiscount=$('[data-deal-discount]');
        if(dealPrice) dealPrice.textContent=money(option.dataset.price);
        const compare=Number(option.dataset.compare), current=Number(option.dataset.price), onSale=compare>current;
        if(dealCompare){dealCompare.hidden=!onSale;dealCompare.textContent=onSale?money(compare):''}
        if(dealDiscount){dealDiscount.hidden=!onSale;dealDiscount.textContent=onSale?`-${Math.round((compare-current)*100/compare)}%`:''}
        const submit=$('[data-add-to-cart]',form);
        if(submit){
          const available=option.dataset.available==='true';
          submit.disabled=!available;
          submit.textContent=available?'ADD TO CART':'SOLD OUT';
        }
      }
    };
    $$('input[type=radio]',form).forEach(i=>i.addEventListener('change',syncVariant));
    select?.addEventListener('change',syncVariant);
    $('[data-product-minus]',form)?.addEventListener('click',()=>{const q=$('input[name=quantity]',form);q.value=Math.max(1,Number(q.value)-1)});
    $('[data-product-plus]',form)?.addEventListener('click',()=>{const q=$('input[name=quantity]',form);q.value=Number(q.value)+1});
    form.addEventListener('submit',async e=>{e.preventDefault();const submit=$('button[type=submit]',form);submit.disabled=true;try{await addProductForm(form)}catch(err){alert(err.message)}finally{submit.disabled=false}});
  }


  // All product media, including uploaded videos, share the gallery controls.
  $$('[data-product-thumb]').forEach(btn=>btn.addEventListener('click',()=>showProductMedia(btn.dataset.mediaId)));

  // Cross-sell "Buy More" forms
  $$('[data-upsell-form]').forEach(upsellForm=>upsellForm.addEventListener('submit',async e=>{
    e.preventDefault();
    const button=$('button[type=submit]',upsellForm);
    button.disabled=true;
    try{await addProductForm(upsellForm)}catch(err){alert(err.message)}finally{button.disabled=false}
  }));

  // Sticky product form
  const stickyForm=$('[data-sticky-product-form]');
  if(stickyForm){
    stickyForm.addEventListener('submit',async e=>{
      e.preventDefault();
      const button=$('button[type=submit]',stickyForm);
      button.disabled=true;
      if(stickyForm.dataset.stickyFollowsMain==='true' && form){
        $('input[name=quantity]',stickyForm).value=$('input[name=quantity]',form)?.value||'1';
      }
      try{await addProductForm(stickyForm)}catch(err){alert(err.message)}finally{button.disabled=false}
    });
  }

  const stickyBar=$('[data-product-sticky-bar]');
  const mainBuyRow=$('[data-main-buy-row]');
  if(stickyBar){
    const updateSticky=()=>{
      const visible=stickyBar.dataset.smartSticky!=='true' || !mainBuyRow || mainBuyRow.getBoundingClientRect().bottom<8;
      stickyBar.classList.toggle('is-visible',visible);
      stickyBar.inert=!visible;
    };
    let pending=false;
    const scheduleUpdate=()=>{
      if(pending) return;
      pending=true;
      requestAnimationFrame(()=>{pending=false;updateSticky()});
    };
    const reserveSpace=()=>document.body.style.paddingBottom=`${stickyBar.offsetHeight}px`;
    updateSticky();
    reserveSpace();
    window.addEventListener('scroll',scheduleUpdate,{passive:true});
    window.addEventListener('resize',scheduleUpdate);
    if(window.ResizeObserver) new ResizeObserver(reserveSpace).observe(stickyBar);
  }

  const stickyVariant=$('[data-sticky-variant]');
  const stickyProductForm=stickyVariant?.closest('[data-sticky-product-form]');
  if(stickyVariant && stickyProductForm){
    stickyVariant.addEventListener('change',()=>{
      const selected=stickyVariant.selectedOptions[0];
      const stickyButton=$('button[type=submit]',stickyProductForm);
      if(stickyButton) stickyButton.disabled=selected?.dataset.available!=='true';

      if(stickyProductForm.dataset.stickyFollowsMain==='true' && form){
        const mainOption=$(`option[value="${stickyVariant.value}"]`, $('[data-variant-select]',form));
        if(!mainOption) return;
        let values=[];try{values=JSON.parse(mainOption.dataset.options)}catch(_){return}
        $$('input[type=radio]',form).forEach((radio)=>{
          const groupIndex=$$('fieldset.variant-group',form).findIndex(fs=>fs.contains(radio));
          if(groupIndex>-1 && radio.value===values[groupIndex]) radio.checked=true;
        });
        const mainSelect=$('[data-variant-select]',form);
        mainSelect.value=stickyVariant.value;
        mainSelect.dispatchEvent(new Event('change',{bubbles:true}));
      }

      updateStickyDetails();
    });
  }
  updateStickyDetails();
})();
